import { Box, styled } from '@mui/material'
import EmergencyIcon from '@mui/icons-material/Emergency'

interface Props {
  value: number
  color: string
}

const Container = styled(Box)`
  width: 200px;
  border-bottom: 1px solid #7f7f7f;
  position: relative;
`

const VerticalLine = styled(Box)<{ align?: string; index?: number }>`
  width: 1px;
  background-color: #7f7f7f;
  position: absolute;
  bottom: 0;

  svg {
    fill: #fff !important;
  }

  ${({ align }) =>
    align === 'left' &&
    `
    left: 0;
    height: 7px;
  `};

  ${({ align }) =>
    align === 'right' &&
    `
    right: 0;
    height: 7px;
  `};

  ${({ align, index }) =>
    align === 'center' &&
    index &&
    `
    left: ${index * 20}px;
    height: 4px;
  `};
`

const IconContainer = styled('div')<{ color: string; value: number }>`
  position: absolute;
  transition: 0.4s;
  left: ${({ value }) => `calc(${((value * 2) / 200) * 100}% - 8px)`};

  svg {
    fill: ${({ color }) => color};
  }
`

function SpecVisualizer({ value, color }: Props) {
  return (
    <Container>
      <VerticalLine align="left" />
      {value !== undefined && value !== null && (
        <IconContainer color={color} value={Number(value)}>
          <EmergencyIcon sx={{ fontSize: '15px' }} />
        </IconContainer>
      )}
      {new Array(10).fill('').map((_item, index) => (
        <VerticalLine key={index} align="center" index={index} />
      ))}
      <VerticalLine align="right" />
    </Container>
  )
}

export default SpecVisualizer
